// TODO: remove this to the server
export const ESV_AUTH_KEY = "46c89b55f417d65fa4e4f7e7beecda0ce0d8fc44";
// TODO: See resetAbortHandling in bible reading plan
export function getPassage(options = {}, signal) {
    options.passage = options.passage || "Genesis 1";
    options.endpoint = options.endpoint || "text";
    return fetch(`https://api.esv.org/v3/passage/${options.endpoint}/?q=${options.passage}&include-chapter-numbers=false&include-short-copyright=false&include-audio-link=false&include-footnotes=false&include-surrounding-chapters-below=false&include-crossrefs=true&crossref-url=https://www.cedarparkchurchofchrist.org/bible?q=`, {
        signal,
        headers: { Authorization: ESV_AUTH_KEY },
    }).then((response) => {
        return response.json();
    });
    /*options.passage = options.passage || 'genesis 1';
  options.bible = options.bible || 'ASV';
  options.outputFormat = options.outputFormat || 'text';
  options.footnotes = options.footnotes || false;
  options.fullText = options.fullText || false;
  options.header = options.header || '';
  options.footer = options.footer || '';
  options.style = options.footer || 'fullyFormatted';

  return fetch(`https://api.biblia.com/v1/bible/content/${options.bible}.${options.outputFormat}.json?passage=${options.passage}&fullText=${options.fullText}&footnotes=${options.footnotes}&header=${options.header}&footer=${options.footer}&style=${options.style}&key=0580a5ebf87779a0c1bb9ff6d2b80c13`).then(response =>
  response.json());*/
    /*
// bible	The ID of the Bible (required).
// passage	The Bible passage to return (required).
// outputFormat	Content type returned (options below)
style	The name of a pre-defined style (options below). **Note: Takes precedence over the more specific options e.g. redLetter, header**
formatting	all, paragraph, character, or none. Default all
redLetter	false to remove red letter formatting for words of Christ. Default true.
//footnotes	true to include footnote content below the main content; default false.
citation	true to include a citation below the content; default false.
paragraphs	true to preserve paragraphs, false for one verse per line; default true.
//fullText	true to include everything, not only the biblical text; default false.
//header	format of the header (see blow); default empty
//eachVerse	format of the footer; default [VerseText]
//footer	format of the footer; default empty
*/
}
